"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelledFields = void 0;
var react_1 = __importDefault(require("react"));
var FormikTextBox_1 = require("./FormikTextBox");
var LabelledField_1 = require("./LabelledField");
/**
 * A convient way to create a list of labelled fields for fast form creation.
 *
 * Children can be any FormikControlProp based control component
 *
 * You can also pass an array as the children in which case you also just specify
 * field names and textboxes will be auto created.
 *
 * @param props
 * @returns
 */
var LabelledFields = function (props) {
    return (react_1.default.createElement(react_1.default.Fragment, null, props.children.map(function (child) {
        if (typeof child === 'string') {
            return (react_1.default.createElement(LabelledField_1.LabelledField, { key: child },
                react_1.default.createElement(FormikTextBox_1.FormikTextBox, { name: child })));
        }
        else {
            return react_1.default.createElement(LabelledField_1.LabelledField, { key: child.props.name }, child);
        }
    })));
};
exports.LabelledFields = LabelledFields;
//# sourceMappingURL=LabelledFields.js.map